import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  // keyframes locali JSS
  '@keyframes typingBounce': {
    '0%, 80%, 100%': { transform: 'scale(0)', opacity: 0.4 },
    '40%': { transform: 'scale(1)', opacity: 1 }
  },

  root: {
    display: 'inline-flex',
    alignItems: 'center',
    // rispetto utenti con riduzione animazioni
    '@media (prefers-reduced-motion: reduce)': {
      '& $dot': { animation: 'none', opacity: 0.8, transform: 'scale(1)' }
    }
  },

  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#666',
    display: 'inline-block',
    animation: '$typingBounce 1200ms infinite ease-in-out both'
  }
});

export const TypingDots = ({
  size = 8,
  gap = 6,
  color = '#666',
  duration = 1200,
  ariaLabel = "L'assistente sta scrivendo…"
}) => {
  const classes = useStyles();

  const styleFor = (delayMs) => ({
    width: size,
    height: size,
    marginLeft: delayMs === 0 ? 0 : gap,
    backgroundColor: color,
    animationDuration: `${duration}ms`,
    animationDelay: `${delayMs}ms`
  });

  return (
    <Box role="status" aria-live="polite" aria-label={ariaLabel} className={classes.root}>
      <span className={classes.dot} style={styleFor(0)} />
      <span className={classes.dot} style={styleFor(160)} />
      <span className={classes.dot} style={styleFor(320)} />
    </Box>
  );
};
